import JSXComponent from "../../../dist/jsx-render/JSXComponent";
import dom from "../../../dist/jsx-render/dom";
import { CheckboxCompoment } from "../../Components/CheckboxComponent";


export type GridViewSelectOptionsProps = {
    model: any;
    // used to display the options horizentally(flex-row) Or vertically (flex-column)
    showInline: boolean;
}

// Component to define the different settings of a listview (use avatars, show result line, etc ...)
export class GridViewSelectOptions extends JSXComponent {
    props: GridViewSelectOptionsProps;

    constructor(props: GridViewSelectOptionsProps) {
        super(props); 
    }

    checkboxUseAvatars = new CheckboxCompoment({
        model: this.props.model,
        field: "UseAvatars",
        label: Resources.Common.useAvatars,
        createFormGroup: false,
        additionalElementClasses: "pr-3"
    })

    checkboxSingleLine = new CheckboxCompoment({
        model: this.props.model,
        field: "SingleLineDisplay",
        label: Resources.Common.singleLineDisplay,
        createFormGroup: false,
        additionalElementClasses:"pr-3"
    })

    checkboxResultLine = new CheckboxCompoment({
        model: this.props.model,
        field: "ResultLineDisplay",
        label: Resources.Common.resultLineDisplay,
        createFormGroup: false,
        additionalElementClasses: "pr-3"
    })

    checkboxHideDuplicates = new CheckboxCompoment({
        model: this.props.model,
        field: "HideDuplicatesOption",
        label: Resources.Common.hideDuplicatesOption,
        createFormGroup: false,
        additionalElementClasses: "pr-3"
    })

    checkboxInlineEdit = new CheckboxCompoment({
        model: this.props.model,
        field: "InlineEdit",
        label: Resources.Common.inlineEdit,
        createFormGroup: false,
        additionalElementClasses: "pr-3"
    })

    element: HTMLElement;

    getElement = () => {
        this.element = <div className="form-group">
            <label className="form-label">{Resources.Common.settings}</label>
            <div className={"d-flex" + (this.props.showInline == false ? " flex-column" : " flex-row")} >

                {this.checkboxUseAvatars.render()}
                {this.checkboxSingleLine.render()}
                {this.checkboxResultLine.render()}
                {this.checkboxHideDuplicates.render()}

                {this.props.model.InlineEdit ?
                    <div>
                        {this.checkboxInlineEdit.render()}
                    </div>
                    : ""}
            </div>
           
        </div>
    }

    render() {
        this.getElement();
        return this.element;
    }
}